module.exports = __webpack_public_path__ + "static/img/2021中国企业上云数智化平台服务领军企业.ddeae2c6.png";